export const TEST_ID = 'toast';
